import React, { useMemo } from 'react';
import styled from 'styled-components';
import { DataGrid } from 'ui-toolkit/components';
import { ColorCurrency, isNegative } from './ColorCurrency';
import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import { IPremiumDetails } from 'types/order/title/IPolicyPremiumDetailsResponse';
import { isNil } from 'lodash';

const StyledDataGrid = styled(DataGrid<IPremiumDetails>)<{ manuallyEdited: boolean }>`
  background-color: ${(props) =>
    props.manuallyEdited ? props.theme.colors.lightGray : props.theme.colors.defaultContentBackground};
  color: ${(props) => (props.manuallyEdited ? props.theme.colors.darkGray : props.theme.colors.defaultContentText)};
`;

const getColumns = (
  disclosed: boolean,
  manuallyEdited: boolean,
  hasOther?: boolean
): IBootstrapTableColumnProps<IPremiumDetails>[] => {
  const formatter = formatterBuilder(manuallyEdited);
  const columns = [
    { text: disclosed ? 'Disclosed' : 'Actual', dataField: 'description', headerStyle: { width: '50%' } },
    { text: 'Buyer', dataField: 'buyer', formatter },
    { text: 'Seller', dataField: 'seller', formatter },
    { text: 'Total', dataField: 'total', formatter },
  ];

  if (hasOther) {
    columns.splice(3, 0, { text: 'Other', dataField: 'other', formatter });
  }
  return columns;
};

const formatterBuilder = (manuallyEdited: boolean) => (column?: number | string) => {
  if (isNil(column)) {
    return <>-</>;
  }
  return <ColorCurrency isNegative={isNegative(column)} value={column} manuallyEdited={manuallyEdited} />;
};

export interface IDisclosedOrActualDataGridProps {
  manuallyEdited: boolean;
  disclosed: boolean;
  isFetching: boolean;
  data: IPremiumDetails[];
  hasOther?: boolean;
}

export const DisclosedOrActualDataGrid: React.FC<IDisclosedOrActualDataGridProps> = ({
  manuallyEdited,
  disclosed,
  isFetching,
  data,
  hasOther,
}) => {
  const columns = useMemo(() => getColumns(disclosed, manuallyEdited, hasOther), [disclosed, manuallyEdited, hasOther]);
  return (
    <StyledDataGrid
      keyField={'description'}
      data={data}
      columns={columns}
      loading={isFetching}
      manuallyEdited={manuallyEdited}
    />
  );
};
